// @charset "utf-8";
import client from './client'
import account from './account'

export default {
    ...client,
    account
}



// WEBPACK FOOTER //
// ./src/api/index.js